"use strict";

import Vue from 'vue';

var print = {};
//compose a single line text
print.singleLine = function(lineMaxSize){
	this.maxSize = lineMaxSize;
	this.stringArray = new Array();
	this.toJson = function() {
		var dataJson = {'maxSize':this.maxSize,'data':this.stringArray,'category':'singleLine'};
		return dataJson;
	};
}
/*isByType
 *	true :  	location  {left -1,center 0, right 1}
 *	false :		location  location >=0
 *
 **/
print.oneString = function(str,textSize,location,bBold,isByType){	
	var result = {'str':str,'textSize':textSize,'location':location,'bBold':bBold,'isByType':isByType};
	return result;	
}

//a long text,maybe will occupy MultiLine
print.singleLineEx = function(str,textSize,bUnderline,bBold,locationType){
	var result = {'str':str,'textSize':textSize,'bUnderline':bUnderline,'bBold':bBold,'locationType':locationType,'category':'singleLineEx'};
	return result;
}

print.barcode1rd = function(str,codetype,width,height,locationType) {
	var dataJson = {'str':str,'codetype':codetype,'width':width,'height':height,'location':locationType,'category':'barcode1rd'};
	return dataJson;
}
print.barcode2rd = function(str,codetype,width,height,locationType) {
	var dataJson = {'str':str,'codetype':codetype,'width':width,'height':height,'location':locationType,'category':'barcode2rd'};
	return dataJson;
}
print.blankLine = function(height){	
	var dataJson = {'height':height,'category':'blankLine'};
	return dataJson;	
}
print.goToNextPage = function(type,value){
    var dataJson = {'typeV':type,'value':value,'category':'feed'};
    return dataJson;
}

print.BarcodeFormat = {
    AZTEC: 0,
    CODABAR: 1,
    CODE_39: 2,
    CODE_93: 3,
    CODE_128: 4,
    DATA_MATRIX: 5,
    EAN_8: 6,
    EAN_13: 7,
    ITF: 8,
    MAXICODE: 9,
    PDF_417: 10,
    QR_CODE: 11,
    RSS_14: 12,
    RSS_EXPANDED: 13,
    UPC_A: 14,
    UPC_E: 15,
    UPC_EAN_EXTENSION: 16
    };

print.onePrintTask = function(){
	this.taskArray = new Array();
	this.toJsonStr = function(){
		return JSON.stringify(this.taskArray);	
	};
}

const Plugin = {
    install: function (Vue) {
        Vue.$print = print;
        window.$print = print;
        Object.defineProperty(Vue.prototype, '$print', {
            value: print
        });
    }
};

Vue.use(Plugin);

export default print;
